/**
 * External dependencies
 */
import { css } from '@emotion/core';
export default css;
//# sourceMappingURL=emotion-css.js.map